import { ISelect, ISelectItem } from 'app/store/models/select.model';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { MessageService } from 'app/store/services/message.service';
import { ETotalCountItem } from 'app/store/models/message.model';
import { SessionService } from 'app/store/services/session.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { IUserSessionData, UserType } from 'app/store/models/user.model';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { CampaignService } from 'app/store/services/campaign.service';

@Component({
  selector: 'app-total-count',
  templateUrl: './total-count.component.html',
  styleUrls: ['./total-count.component.scss'],
})
export class TotalCountComponent implements OnInit, OnDestroy {
  @Input() showInboxStatus: boolean;

  iconCircle = faCircle;

  totalSentToday: number;

  sendLimit: number;

  targetCount: number;

  showType;

  userData: IUserSessionData;

  activeItem: ETotalCountItem = ETotalCountItem.ALL;

  showAll: boolean;

  selectProperties: ISelect<any> = {
    defaultValue: ETotalCountItem.ALL,
    label: 'Select...',
    items: [
      {
        label: 'Total',
        value: ETotalCountItem.ALL,
      },
      {
        label: '7 Days',
        value: ETotalCountItem.SEVEN_DAYS,
      },
      {
        label: '30 Days',
        value: ETotalCountItem.ONE_MONTH,
      },
      {
        label: '6 Months',
        value: ETotalCountItem.SIX_MONTHS,
      },
      {
        label: '1 Year',
        value: ETotalCountItem.ONE_YEAR,
      },
    ],
  };

  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private messagesService: MessageService,
    private sessionService: SessionService,
    private readonly campaignsService: CampaignService
  ) {}

  ngOnInit() {
    this.sessionService
      .onChanges()
      .pipe(takeUntil(this.destroy$))
      .subscribe((sessionData: IUserSessionData) => {
        if (
          sessionData.user_type === UserType.SINGLE_USER
        ) {
          this.showType = 'total';
          this.getStatus();
        }

        this.userData = sessionData;
      });
  }

  getStatus() {
    const sentLimit = localStorage.getItem('send_limit');
    const sentCampaigns = localStorage.getItem('sent_campaigns');

    if (sentLimit && sentCampaigns) {
      this.sendLimit = parseInt(sentLimit, 10);
      this.totalSentToday = parseInt(sentCampaigns, 10);
      this.updateCount();
      return;
    }
    this.campaignsService.getSentMessagesCount().subscribe(result => {
      this.totalSentToday = result.sent_campaigns;
      this.sendLimit = result.send_limit;

      localStorage.setItem('send_limit', this.sendLimit.toString());
      localStorage.setItem('sent_campaigns', this.totalSentToday.toString());
      this.updateCount();
    });
  }

  ngOnDestroy() {
    this.destroy$.next(false);
  }

  updateCount(filter: ETotalCountItem = ETotalCountItem.ALL) {
    this.messagesService.getTotalMessagesCount(filter).subscribe(result => {
      this.targetCount = result.total_sent;
    });
  }

  onSelection(value) {
    this.targetCount = undefined;
    this.updateCount(value);
  }

  selectItem(item: ISelectItem) {
    if (!this.showAll) {
      this.showAll = true;
      return;
    }

    this.targetCount = undefined;
    this.updateCount(item.value);
    this.activeItem = item.value;
    this.showAll = false;
  }
}
